import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  get className () {
    return this.element.dataset.classname
  }

  toggleAccordion (e) {
    e.preventDefault()

    const target = e.target.parentNode
    if (target.classList.contains(`${this.className}::accordion-open`)) {
      target.classList.remove(`${this.className}::accordion-open`)
    } else {
      target.classList.add(`${this.className}::accordion-open`)
    }
  }
}
